import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertFactoryOptions } from './expert-factory-options.component';

@Directive({
  selector: '[factoryPlaceholderNullOnClick]'
})

export class FactoryPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expertFacOptions : ExpertFactoryOptions) {
   }
    @Output()
    public factoryPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {   
            this.expertFacOptions.expertFactoryOptions="";
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-factory-options/expert-factory-placeholder-null.ts